import { Component, ViewContainerRef, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { filter, map, switchMap, skipWhile, takeUntil, take } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

import { GoogleAnalyticsService, KeybindService, ShellService } from '~core/services';
import { isPropertyRoute } from '~/main/components/main-view.component';

@Component({
  selector: 'idap-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: { '(window:keydown)': 'keybindService.emitKeypress($event)' }
})
export class AppComponent implements OnDestroy {
  title = 'IDAP';
  destroyed: Subject<void> = new Subject<void>();

  constructor(
    vcr: ViewContainerRef,
    shell: ShellService,
    private keybindService: KeybindService,
    private googleAnalytics: GoogleAnalyticsService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    shell.setRootElement(vcr);

    googleAnalytics.initialize();

    const routeEnd = router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    );

    routeEnd.pipe(
      map(() => this.route),
      map((currentRoute) => {
        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }
        return currentRoute;
      }),
      switchMap((currentRoute) => {
        return currentRoute.paramMap.pipe(
          map((paramMap) => paramMap.keys),
          take(1)
        );
      }),
      filter((routeKeys) => !!routeKeys),
      skipWhile((routeKeys, index) => {
        // Because of the challenges of the current navigation architecture
        // property pageviews will be logged in PropertyDetailPopupComponent.
        const isInitialPropertyRoute = index === 0 ? isPropertyRoute(routeKeys) : false;
        const isAuthResetRoute = this.router.url.startsWith('/auth/reset');

        return isInitialPropertyRoute || isAuthResetRoute;
      }),
      takeUntil(this.destroyed)
    )
      .subscribe((_) => this.googleAnalytics.logPageview(this.router.url));
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts